import React, { useEffect } from "react";
import { redirectUserToLogin } from "server/kas/utils";

const Login: React.FC = () => {
  useEffect(() => {
    redirectUserToLogin();
  }, []);

  return <></>;
};

export default Login;
